/**
 * Items created before the on-sale flag existed carry no `isEnabled` value, so
 * only an explicit `false` means disabled. A falsy check would read every one
 * of them as off sale.
 */
export function isItemDisabled(item: { isEnabled?: boolean }): boolean {
  return item.isEnabled === false;
}
